import React from 'react'
import cx from 'classnames'
import { Message } from 'intl'
import dayjs from 'date'

import { Text } from 'components/dataDisplay'

import OrderItemBase from 'compositions/orderItems/OrderItemBase/OrderItemBase'
import OrderItemRemoveButton from 'compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton'

import messages from './messages'


type GiftCardOrderItemProps = {
  className?: string
  data: OrderItems.GiftCard
  withRemoveButton?: boolean
}

const GiftCardOrderItem: React.FunctionComponent<GiftCardOrderItemProps> = (props) => {
  const { className, data: { price, recipient, productId, type, sender }, withRemoveButton } = props

  return (
    <OrderItemBase className={cx(className, 'flex items-start')} data-testid="orderGiftCard">
      {
        withRemoveButton && (
          <OrderItemRemoveButton
            input={{
              giftCardItem: {
                productId,
                type,
                recipient,
              },
            }}
            metadata={{
              productType: 'Gift card',
              placement: 'Drawer cart',
              productId,
            }}
          />
        )
      }
      <Text
        className="flex-none bg-gold-30 text-white px-16 py-12 radius-5"
        style="h6"
        message={price}
      />
      <div className="flex-1 min-w-1 ml-40 break-words">
        <Text style="p2">
          <p>
            <Message value={messages.to} html />&nbsp;{recipient.name}<br />{recipient.email}
          </p>
          {
            Boolean(sender?.name) && (
              <p>
                <Message value={messages.from} html />&nbsp;{sender.name}
              </p>
            )
          }
          <p>
            <Message value={{ ...messages.value, values: { price } }} html />
          </p>
          {
            Boolean(recipient.date) && (
              <p>
                <Message value={{ ...messages.date, values: { date: dayjs(recipient.date).format('L') } }} html />
              </p>
            )
          }
        </Text>
      </div>
    </OrderItemBase>
  )
}


export default GiftCardOrderItem
